<!--suppress HtmlDeprecatedAttribute, CssUnknownProperty, XmlUnusedNamespaceDeclaration -->
<template>
  <span :class="classes">
  <b>{{ title }}</b>
      <b v-if="isOff">off</b>
            <b v-else>
              <svg v-if="isOil" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="-384.5 204.1 70 103.1" style="enable-background:new -384.5 204.1 70 103.1;" xml:space="preserve">
                  <path fill="#000" d="M-347.1,205.3c-1-1.5-3.6-1.5-4.6,0c-1.3,2-32.7,48.5-32.7,66.9c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35
                          C-314.4,253.8-345.8,207.2-347.1,205.3z M-342.3,295.9c0,1.9-1.6,3.5-3.5,3.5c-16.4,0-29.8-13.4-29.8-29.8c0-1.9,1.6-3.5,3.5-3.5
                          c1.9,0,3.5,1.6,3.5,3.5c0,12.6,10.2,22.8,22.8,22.8C-343.9,292.4-342.3,293.9-342.3,295.9z"/>
              </svg>
               <svg v-if="isHigh" class="heat" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="256 -186.3 256 512" style="enable-background:new 256 -186.3 256 512;" xml:space="preserve">
                <path style="fill:#f26522;" d="M469.3,102.3v-203.3c0-47.1-38.2-85.3-85.3-85.3s-85.3,38.2-85.3,85.3v203.3c-26.2,23.4-42.7,57.5-42.7,95.4
                            c0,70.7,57.3,128,128,128s128-57.3,128-128C512,159.8,495.5,125.8,469.3,102.3z M384,283.1c-47.1,0-85.3-38.2-85.3-85.3
                            c0-24.6,10.4-47.5,28.5-63.6l14.2-12.7v-222.3c0-23.6,19.1-42.7,42.7-42.7s42.7,19.1,42.7,42.7v222.3l14.2,12.7
                            c18,16.1,28.5,39,28.5,63.6C469.3,244.9,431.1,283.1,384,283.1z"/>
                <path style="fill:#f26522;" d="M405.3,137.4v-153h-42.7v153c-24.9,8.8-42.7,32.5-42.7,60.3c0,35.3,28.7,64,64,64c35.3,0,64-28.7,64-64
                    C448,169.9,430.2,146.2,405.3,137.4z"/>
              </svg>
              <svg v-if="isCritical" class="critical" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="256 -186.3 256 512" style="enable-background:new 256 -186.3 256 512;" xml:space="preserve">
                <path style="fill: #ff0000;" d="M469.3,102.3v-203.3c0-47.1-38.2-85.3-85.3-85.3s-85.3,38.2-85.3,85.3v203.3c-26.2,23.4-42.7,57.5-42.7,95.4
                            c0,70.7,57.3,128,128,128s128-57.3,128-128C512,159.8,495.5,125.8,469.3,102.3z M384,283.1c-47.1,0-85.3-38.2-85.3-85.3
                            c0-24.6,10.4-47.5,28.5-63.6l14.2-12.7v-222.3c0-23.6,19.1-42.7,42.7-42.7s42.7,19.1,42.7,42.7v222.3l14.2,12.7
                            c18,16.1,28.5,39,28.5,63.6C469.3,244.9,431.1,283.1,384,283.1z"/>
                <path style="fill: #ff0000;" d="M405.3,137.4v-153h-42.7v153c-24.9,8.8-42.7,32.5-42.7,60.3c0,35.3,28.7,64,64,64c35.3,0,64-28.7,64-64
                    C448,169.9,430.2,146.2,405.3,137.4z"/>
              </svg>
            </b>
          </span>
</template>

<script>
const POWER = 1
const OIL = 2
const HIGH = 4
const CRITICAL = 8

export default {
  name: 'DMCR',
  props: [
    'state',
    'title'
  ],
  computed: {
    classes () {
      if (!Number.isInteger(this.state)) {
        return [
          'main-stations__dmcr_item_new',
          'grey'
        ]
      }
      if ((this.state & POWER) === 0) {
        return [
          'main-stations__dmcr_item_new',
          'orange',
          'off'
        ]
      }

      let classes = ['main-stations__dmcr_item_new']

      if ((this.state & OIL) !== 0) {
        classes = [
          'main-stations__dmcr_item_new',
          'orange'
        ]
      }

      if ((this.state & HIGH) !== 0) {
        classes = [
          'main-stations__dmcr_item_new',
          'orange'
        ]
      }

      if ((this.state & CRITICAL) !== 0) {
        classes = [
          'main-stations__dmcr_item_new',
          'red'
        ]
      }

      return classes
    },
    isOff () {
      return (Number.isInteger(this.state) && ((this.state & POWER) === 0))
    },
    isHigh () {
      return (Number.isInteger(this.state) && ((this.state & HIGH) !== 0))
    },
    isOil () {
      return (Number.isInteger(this.state) && ((this.state & OIL) !== 0))
    },
    isCritical () {
      return (Number.isInteger(this.state) && ((this.state & CRITICAL) !== 0))
    }
  }
}
</script>
